import { convert } from 'jcampconverter';

import { version, dependencies, devDependencies } from '../package.json';

import { getInfoFromJCAMP } from './utils/getInfoFromJCAMP';

export function fromJCAMP(buffer) {
  let parsedData = convert(buffer, {
    noContour: true,
    xy: true,
    keepRecordsRegExp: /.*/,
    profiling: true,
  });
  let dataStructure = [];
  let entries = parsedData.flatten;
  for (let entry of entries) {
    if ((entry.spectra && entry.spectra.length > 0) || entry.minMax) {
      let info = getInfoFromJCAMP(Object.assign({}, entry.info, entry.meta));
      let dimensions = [];
      let dependentVariables = [];

      let dependentVariable = {};
      if (info.dimension === 1) {
        dependentVariable.components = entry.spectra;
      } else if (info.dimension === 2) {
        dependentVariable.components = entry.minMax;
      }
      let dimension = {
        increment: info.increment,
        numberOfPoints: info.numberOfPoints,
      };

      if (info.fid) {
        dimension.coordinatesOffset = {
          magnitude: -info.digitalFilter * info.increment,
          units: 'second',
        };
      } else {
        dimension.coordinatesOffset = {
          magnitude:
            info.frequencyOffset / info.baseFrequency - 0.5 * info.spectraWidth,
          units: 'ppm',
        };
      }

      dimensions.push(dimension);
      dependentVariables.push(dependentVariable);
      dataStructure.push({
        dimensions,
        dependentVariables,
        info,
        meta: entry.info,
        timeStamp: new Date().valueOf(),
        version: [{ 'nmr-parser': version }, dependencies, devDependencies],
      });
    }
  }

  return dataStructure;
}
